import type { FC, ReactNode } from 'react';
import { Flex, Typography } from '@ui';
import styles from './Card.module.css';

type Props = {
    imageSrc: string;
    title: string;
    description: string;
    footer?: {
        text?: string;
        icon?: ReactNode;
    };
};

export const Card: FC<Props> = ({ imageSrc, title, description, footer }) => (
    <Flex vertical className={styles.eventCard}>
        <img src={imageSrc} alt={title} className={styles.image} />
        <Flex vertical justify="space-between" className={styles.content}>
            <Flex vertical gap={16}>
                <Typography.Heading level={4} color="textPrimary">{title}</Typography.Heading>
                <div className={styles.description}>
                    <Typography.Paragraph level={2} color="textPrimary">{description}</Typography.Paragraph>
                </div>
            </Flex>
            {footer && (
                <Flex align="center" gap={8} className={styles.footer}>
                    {footer.icon}
                    {footer.text && <Typography.Description>{footer.text}</Typography.Description>}
                </Flex>
            )}
        </Flex>
    </Flex>
);
